import { useCallback } from "react";
import { axiosSettings } from "./axios";

export const useDeleteOrganisationTeam = () => {
  const [state, execute, cancel] = axiosSettings<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (organisationId: string, teamId: string) => {
      return execute({
        url: `/v2/organisations/${organisationId}/${teamId}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
